import { ProgramHeaderCenterView } from "@modules/programs/components/programHeader/programHeaderCenterView"
import { ProgramHeaderLeftView } from "@modules/programs/components/programHeader/programHeaderLeftView"
import { ProgramHeaderRightView } from "@modules/programs/components/programHeader/programHeaderRightView"
import { ProgramInfinite } from "@modules/programs/programInfiniteTypes"
import { ProgramOnOff } from "@modules/programs/programOnOffTypes"

type ProgramHeaderProps = {
  program?: ProgramInfinite | ProgramOnOff
}
export const ProgramHeader: React.FC<ProgramHeaderProps> = ({ program }) => {
  return (
    <div className="grid mb-5" style={{ height: 200 }}>
      <div className="col-3 py-0">
        <ProgramHeaderLeftView />
      </div>
      <div className="col-6 py-0">
        <ProgramHeaderCenterView program={program} />
      </div>
      <div className="col-3 py-0">
        <ProgramHeaderRightView program={program} />
      </div>
    </div>
  )
}
